import { ref, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase/auth.firebase";

const getFileDownloadURL = (filePath: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        getDownloadURL(ref(storage, filePath))
            .then((url) => {
                resolve(url);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const downloadFile = (infoId: string, fileName: string, bucketName: string): Promise<string> => {
    return getFileDownloadURL(`infographic_images/${infoId}/${bucketName}/${fileName}`);
};

export const downloadFileAudio = (mediaId: string): Promise<string> => {
    return getFileDownloadURL(`audio_files/${mediaId}.mp3`);
};